import React, { useState, useEffect, useRef } from 'react';
// import useSearch, { SORT_TYPE_VALS } from '../../../context/search/useSearch'
import useSearch from '../../../context/search/useSearch'
import useLangStrings from '../../../hooks/useLangStrings'

interface SearchSortByProps {
  pendingSortKey: string;
  setPendingSortKey: (key: string) => void;
}

const SearchSortBy: React.FC<SearchSortByProps> = ({ pendingSortKey, setPendingSortKey }): JSX.Element => {
  const langStrings = useLangStrings(JSON.stringify(window['sortBy'].strings))

  const { outputSortElement, sortKey, markFiltersChanged, productSearchResult } = useSearch();

  // Don't show sort if there are no results
  if (!productSearchResult || productSearchResult.total === 0) {
    return null;
  }

  // Accordion open/close state
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Sync local state with context sortKey when it changes externally
  useEffect(() => {
    setPendingSortKey(sortKey || 'null');
    // eslint-disable-next-line
  }, [sortKey]);

  // Click-off logic to close accordion
  useEffect(() => {
    // eslint-disable-next-line
    if (!open) return () => {};

    const handleClickOff = (e: MouseEvent) => {
      const el = e.target as HTMLElement

      const searchPortal = el.closest('[data-search-filters-slide-out]');

      if (searchPortal) return

      setOpen(false);
    };

    document.body.addEventListener('click', handleClickOff);
    return () => document.body.removeEventListener('click', handleClickOff);
  }, [open]);

  // Accordion label (use lang string or fallback)
  const label = langStrings.sort_button || 'Sort by';

  return (
    <div className={`filter__filter${open ? ' filter__filter--open' : ''}`} ref={containerRef}>
      <button
        type="button"
        onClick={() => {
          setOpen(o => !o);
        }}
        className={`filter__title${open ? ' filter__title--open' : ''}`}
      >
        {label}
      </button>
      {open && (
        <div className="filter__options filter__options--single filter__options--sort">
          <div className="filter__items filter__items--sort filter__items--box">
            {outputSortElement.map(sort => (
              <label
                key={sort.id}
                className={`filter__option filter__option--single${pendingSortKey === sort.id ? ' filter__option--selected' : ''} filter__option--sort`}
              >
                <input
                  type="radio"
                  name="sort"
                  value={sort.id}
                  checked={pendingSortKey === sort.id}
                  onChange={() => {
                    setPendingSortKey(sort.id);
                    markFiltersChanged();
                  }}
                  className="visually-hidden"
                />
                <span className="filter__label">{sort.label}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchSortBy
